/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateEventSettingTemplateRequest,
    EditEventSettingTemplateRequest,
    IdResponse,
} from '../models';

export interface EventSettingTemplateApiControllerCreateEventSettingTemplateRequest {
    createEventSettingTemplateRequest: CreateEventSettingTemplateRequest;
}

export interface EventSettingTemplateApiControllerEditEventSettingTemplateRequest {
    templateId: string;
    editEventSettingTemplateRequest: EditEventSettingTemplateRequest;
}

/**
 * 
 */
export class EventSettingTemplateApi extends runtime.BaseAPI {

    /**
     */
    async eventSettingTemplateApiControllerCreateEventSettingTemplateRaw(requestParameters: EventSettingTemplateApiControllerCreateEventSettingTemplateRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.createEventSettingTemplateRequest === null || requestParameters.createEventSettingTemplateRequest === undefined) {
            throw new runtime.RequiredError('createEventSettingTemplateRequest','Required parameter requestParameters.createEventSettingTemplateRequest was null or undefined when calling eventSettingTemplateApiControllerCreateEventSettingTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/event-setting-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createEventSettingTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async eventSettingTemplateApiControllerCreateEventSettingTemplate(requestParameters: EventSettingTemplateApiControllerCreateEventSettingTemplateRequest): Promise<IdResponse> {
        const response = await this.eventSettingTemplateApiControllerCreateEventSettingTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async eventSettingTemplateApiControllerEditEventSettingTemplateRaw(requestParameters: EventSettingTemplateApiControllerEditEventSettingTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling eventSettingTemplateApiControllerEditEventSettingTemplate.');
        }

        if (requestParameters.editEventSettingTemplateRequest === null || requestParameters.editEventSettingTemplateRequest === undefined) {
            throw new runtime.RequiredError('editEventSettingTemplateRequest','Required parameter requestParameters.editEventSettingTemplateRequest was null or undefined when calling eventSettingTemplateApiControllerEditEventSettingTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/event-setting-templates/{templateId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editEventSettingTemplateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async eventSettingTemplateApiControllerEditEventSettingTemplate(requestParameters: EventSettingTemplateApiControllerEditEventSettingTemplateRequest): Promise<void> {
        await this.eventSettingTemplateApiControllerEditEventSettingTemplateRaw(requestParameters);
    }

}
